/**
 * Whether new users can create accounts directly (signups on) or are funneled
 * into the waitlist (signups off).
 *
 * Flip this by setting NEXT_PUBLIC_SIGNUPS_ENABLED in the environment and
 * redeploying. Defaults to enabled (open) when unset; set it to "false" to
 * close signups and turn the waitlist back on.
 */
export function isSignupsEnabled(): boolean {
  return process.env.NEXT_PUBLIC_SIGNUPS_ENABLED !== "false";
}

/** The route new users should be sent to, based on the current auth mode. */
export function getSignupHref(): string {
  return isSignupsEnabled() ? "/auth/sign-up" : "/auth/waitlist";
}
